"use strict";

exports.__esModule = true;
exports.TICKET_STATUS_OPEN = exports.LINK_TYPE_MAXIMO = exports.LINK_STATUS_LINKING = exports.LINK_STATUS_LINKED = exports.LINK_STATUS_LINK = exports.LINK_STATUS_FAILED = void 0;
var LINK_STATUS_LINK = exports.LINK_STATUS_LINK = "LINK";
var LINK_STATUS_LINKED = exports.LINK_STATUS_LINKED = "LINKED";
var LINK_STATUS_LINKING = exports.LINK_STATUS_LINKING = "LINKING";
var LINK_STATUS_FAILED = exports.LINK_STATUS_FAILED = "FAILED";
var LINK_TYPE_MAXIMO = exports.LINK_TYPE_MAXIMO = "MAXIMO";
var TICKET_STATUS_OPEN = exports.TICKET_STATUS_OPEN = "OPEN";